import React from 'react';
import { Circles } from 'react-loader-spinner';
import { IconProps } from '../../Icon';

interface LoadingIconProps extends IconProps {
  color?: string;
}
const LoadingIcon: React.FC<LoadingIconProps> = ({ size, color = 'gray' }) => {
  return (
    <div className="flex items-center flex-col text-center justify-center">
      <Circles color={color} height={size} width={size} />
    </div>
  );
};

export default LoadingIcon;
